/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_History_EmptyInputs */

const cs_ebr_history_empty = /** @type {(inputs: Ebr_History_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatím žádné importy.`)
};

const en_ebr_history_empty = /** @type {(inputs: Ebr_History_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No imports yet.`)
};

/**
* | output |
* | --- |
* | "No imports yet." |
*
* @param {Ebr_History_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_history_empty = /** @type {((inputs?: Ebr_History_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_History_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_history_empty(inputs)
	return cs_ebr_history_empty(inputs)
});